import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { convertMarkdownToHtml } from "helpers/markdown";

export const Overview = ({ connector }) => {
   if (!connector) return <></>;

   const htmlContent = connector.documentation
      ? convertMarkdownToHtml(connector.documentation)
      : "";

   return (
      <SoftBox className="overview">
         <SoftBox
            className="border-top"
            sx={{
               padding: "32px 12px"
            }}
         >
            <SoftBox
               sx={{
                  textAlign: "left",
                  padding: `${htmlContent ? "" : "48px"} 0 ${htmlContent ? "" : "64px"}`
               }}
            >
               {!htmlContent && (
                  <SoftTypography fontSize="16px" sx={{ textAlign: "center" }}>
                     No documentation available
                  </SoftTypography>
               )}
               {htmlContent && (
                  <div className="markdown-rendered-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
               )}
            </SoftBox>
         </SoftBox>
      </SoftBox>
   );
};
